/**
 * The type of pointer for a [[PointerEvent]].
 */
export enum PointerType {
  Touch = 'Touch',
  Mouse = 'Mouse',
  Pen = 'Pen',
  Unknown = 'Unknown'
}
